import { APP_ORIGIN } from '@/config/consts'

export interface Entity {
  name: string
  logo: string
  description?: string
  url?: string
  addresses: Record<string, string>
  social?: {
    twitter?: string
    discord?: string
    github?: string
  }
}

export type Entities = Map<string, Entity>

/**
 * Known entities (governors/curators) for Base mainnet (8453)
 * Sourced from euler-protocol-monorepo/packages/euler-labels/src/8453/entities.ts
 */
export const entities: Entities = new Map([
  [
    'clearstar',
    {
      name: 'Clearstar',
      logo: '/curators/clearstar.svg',
      description:
        'Designing and curating institutional-grade strategies across decentralized markets, underpinned by rigorous risk management.',
      url: 'https://www.clearstar.xyz/',
      addresses: {
        '0x65A067b5955F11F6202F14C3b9Cd64830C4170fB': 'Clearstar Governor',
        '0x30988479C2E6a03E7fB65138b94762D41a733458': 'Curator Wallet 1 (ForDeFi MPC)',
        '0x72882eb5D27C7088DFA6DDE941DD42e5d184F0ef': 'Curator Wallet 2 (ForDeFi MPC)',
      },
      social: { twitter: 'ClearstarLabs' },
    },
  ],
  [
    'hypurrfi',
    {
      name: 'HypurrFi',
      logo: `${APP_ORIGIN}/assets/protocols/hypurrfi.svg`,
      description: 'A decentralized lending and borrowing protocol on HyperEVM.',
      url: APP_ORIGIN,
      addresses: {},
      social: {
        twitter: 'hypurrfi',
      },
    },
  ],
  [
    'euler-dao',
    {
      name: 'Euler DAO',
      logo: 'https://app.euler.finance/entities/euler.svg',
      description:
        'The Euler DAO is the organisation responsible for the creation of the Euler lending/borrowing platform.',
      url: 'https://euler.finance/',
      addresses: {
        '0x1e13B0847808045854Ddd908F2d770Dc902Dcfb8': 'Euler DAO Multisig',
        '0xfe959D7A49EAE5Aaa821b71de315Fb3Adc7a52Ad': 'Euler Vault Access Control Governor',
      } as Record<string, string>,
      social: {
        twitter: 'eulerfinance',
        github: 'euler-xyz',
      },
    },
  ],
  [
    'gauntlet',
    {
      name: 'Gauntlet',
      logo: 'https://app.euler.finance/entities/gauntlet.svg',
      description:
        "Gauntlet's applied research and optimization teams model market risk, economic incentives, and drive sustainable growth for crypto's top protocols, chains, and onchain treasuries.",
      url: 'https://www.gauntlet.xyz/',
      addresses: {
        '0xfe959D7A49EAE5Aaa821b71de315Fb3Adc7a52Ad': 'Euler Vault Access Control Governor',
      } as Record<string, string>,
      social: {
        twitter: 'gauntlet_xyz',
      },
    },
  ],
  [
    'apostro',
    {
      name: 'Apostro',
      logo: 'https://app.euler.finance/entities/apostro.png',
      description: 'Building a better way to self-regulate markets to avoid oracle attacks.',
      url: 'https://www.apostro.xyz/',
      addresses: {
        '0xfD4CD4f4e6e7288E5F68af2D282Cfb872Cea144C': 'Apostro Timelock',
        '0xf726311F85D45a7fECfFbC94bD8508a0A39958c6': 'Apostro Multisig',
      } as Record<string, string>,
      social: {
        twitter: 'apostroxyz',
      },
    },
  ],
  [
    're7-labs',
    {
      name: 'Re7 Labs',
      logo: 'https://app.euler.finance/entities/re7labs.png',
      description:
        'Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to on-chain vaults.',
      url: 'https://www.re7labs.xyz/',
      addresses: {
        '0x184d597Be309e11650ca6c935B483DcC05551578': 'Re7 Labs Euler Multisig',
      } as Record<string, string>,
      social: {
        twitter: 'Re7Labs',
      },
    },
  ],
  [
    'alterscope',
    {
      name: 'Alterscope',
      logo: 'https://app.euler.finance/entities/alterscope_wb.png',
      description:
        'Alterscope provides the platform for processing and modelling risk in real-time across chains, protocols, and liquidity pools.',
      url: 'https://www.alterscope.org/',
      addresses: {
        '0x2e571f334fe06A6a2741dd0E4cb5Bc7C1F8Af808': 'Alterscope Multisig',
      } as Record<string, string>,
      social: {
        twitter: 'Alterscope',
      },
    },
  ],
  [
    'edge-capital',
    {
      name: 'Edge UltraYield',
      logo: 'https://app.euler.finance/entities/edge.png',
      description:
        'Edge Capital is a leading market-neutral hedge fund that manages capital for largest fund of funds, institutional investors and leading crypto foundations and treasuries since 2020',
      url: 'https://edgecapital.xyz/',
      addresses: {
        '0x1280e86Cd7787FfA55d37759C0342F8CD3c7594a': 'Edge Capital Multisig',
      } as Record<string, string>,
      social: {
        twitter: 'EdgeCapitalMgmt',
      },
    },
  ],
  [
    'alphagrowth',
    {
      name: 'AlphaGrowth',
      logo: 'https://app.euler.finance/entities/alphagrowth.svg',
      description:
        'Real stewardship, real growth. AlphaGrowth drives the blockchain industry forward by expanding token utility and accessibility through strategic partnerships and integrations.',
      url: 'https://alphagrowth.io/',
      addresses: {
        '0x4f894Bfc9481110278C356adE1473eBe2127Fd3C': 'Reservoir DAO Multisig',
      } as Record<string, string>,
      social: {
        twitter: 'alphagrowth1',
      },
    },
  ],
])

export function getEntities(): Entities {
  return entities
}
